import {TrDialog} from "../../Models/tr-dialog";
import {SettingsDialog} from '../../Models/settings-dialog';

const SettingsDialogView = require('./settings-dialog.html');

export interface SettingsEntry {
  id: string;
  name: string;
}

interface IScope extends ng.IScope {
  dialog: TrDialog;
  entries: SettingsEntry[];
  callback: (entry: SettingsEntry) => void;
  select: (entry: SettingsEntry) => void;
}

export const SettingsDialogDirective = [
  () => {
    return {
      restrict: 'E',
      scope: {instance: '='},
      templateUrl: SettingsDialogView,
      link: (scope: IScope, element, attrs) => {
        scope.dialog = new TrDialog();

        scope.$watch('instance', (value: SettingsDialog) => {
          value.open = (callback: (entry: SettingsEntry) => void) => {
            scope.callback = callback;
            scope.dialog.open();
            scope.entries = [{id: 'password', name: 'Passwort ändern'}, {id: 'logout', name: 'Abmelden'}];
          };
        });

        scope.select = (entry: SettingsEntry) => {
          scope.callback(entry);
          scope.dialog.close();
        };
      },
    }
  }
];